// extracted by mini-css-extract-plugin
export default {"conteiner":"About_conteiner__mcegF","myPhotoConteiner":"About_myPhotoConteiner__j322P","aboutConteiner":"About_aboutConteiner__FbAqb"};